import { render, staticRenderFns } from "./initiatives.vue?vue&type=template&id=25829235&scoped=true"
import script from "./initiatives.vue?vue&type=script&lang=js"
export * from "./initiatives.vue?vue&type=script&lang=js"
import style0 from "./initiatives.vue?vue&type=style&index=0&id=25829235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25829235",
  null
  
)

export default component.exports